<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'N. provvedimento'"
    [valueInput]="element.esito?.numeroEsito"></div>
<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'Tipo provvedimento'"
    [valueInput]="element.esito?.tipoEsito.descrizione"></div>
<!-- <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Societ&agrave;'"
    [valueInput]="element.esito?.societa.nome"></div> -->